import React from "react";

const ErrorModal = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "20px",
          textAlign: "center",
          border: "2px solid red",
          borderRadius: "5px",
          width: "500px",
        }}
      >
        <p style={{ textAlign: "left" ,fontWeight:"bold"}}>{message}</p>
        <button
          onClick={onClose}
          style={{
            marginTop: "10px",
            padding: "8px 16px",
            border: "none",
            background: "#07b1b0",
            color: "white",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;
